const enableNode = document.querySelector( '#wcbt_maxsale_popup_enable' );
const repeatOpenNode = document.querySelector( '#wcbt_repeat_open' );
const repeatOpenTimeNode = document.querySelector( '#wcbt_repeat_open_time' );

const wcbtMaxSale = () => {
	enableField();
};

const enableField = () => {
	if ( ! enableNode ) {
		return;
	}

	handle( enableNode );
	enableNode.addEventListener( 'change', function( event ) {
		handle( this );
	} );
};

const handle = ( enableNode ) => {
	const fieldWrapperNodes = document.querySelectorAll( '.wcbt-field-wrapper' );

	if ( ! fieldWrapperNodes ) {
		return;
	}
	const enableFieldWrapperNode = enableNode.closest( '.wcbt-field-wrapper' );
	for ( let i = 0; i < fieldWrapperNodes.length; i++ ) {
		const fieldWrapperNode = fieldWrapperNodes[ i ];
		if ( fieldWrapperNode === enableFieldWrapperNode ) {
			continue;
		}

		if ( enableNode.checked ) {
			fieldWrapperNode.style.display = 'flex';
			enableRepeatOpen();
		} else {
			fieldWrapperNode.style.display = 'none';
		}
	}
};

const handleEnableRepeatOpen = ( repeatOpenNode ) => {
	if ( ! repeatOpenTimeNode ) {
		return;
	}

	const field = repeatOpenTimeNode.closest( '.wcbt-field-wrapper' );
	if ( repeatOpenNode.checked ) {
		field.style.display = 'flex';
	} else {
		field.style.display = 'none';
	}
};

const enableRepeatOpen = () => {
	if ( ! repeatOpenNode ) {
		return;
	}

	handleEnableRepeatOpen( repeatOpenNode );
	repeatOpenNode.addEventListener( 'change', function( event ) {
		handleEnableRepeatOpen( this );
	} );
};

export default wcbtMaxSale;
